import { BookingDB, LookupRequest } from "BookingSystem/db/BookingLightDB"
import { observable, computed, autorun, action } from "mobx"
import { Dayjs } from "dayjs"
import dayjs from "dayjs"
import { BookingFlow } from "BookingSystem/BookingFlow"
import { Session } from "BookingSystem/db/Session"
import { DateUtils } from "react-day-picker"

export class DailyQuickView {
  constructor(db: BookingDB, flow: BookingFlow) {
    this.db = db
    this.flow = flow

    autorun(() => {
      if (this.flow.sessionTypes && this.currentDate) {
        this.watchTodaysSessions()
      }
    })
  }

  db: BookingDB
  flow: BookingFlow

  @observable
  currentDate: Dayjs = dayjs()

  async watchTodaysSessions() {
    const neededLookups: LookupRequest[] = []
    const sync = this.db.createSyncRequest()
    this.flow.sessionTypes &&
      this.flow.sessionTypes.forEach(sessionType => {
        sessionType.lookupsForDay(this.currentDate).forEach(lookup => {
          const found = this.db.lookupLocal(lookup)
          if (!found) neededLookups.push(lookup)
        })
      })
    sync.lookupRequests = sync.lookupRequests.concat(neededLookups)
    const res = await this.db.postSyncRequest(sync)
    return res
  }

  unWatchTodaysSessions() {}

  componentDidMount() {}

  componentWillUnMount() {
    this.unWatchTodaysSessions()
  }

  @action.bound
  async updateCapacity(session: Session, newCapacity: number) {
    if (newCapacity < session.numberBooked) {
      alert(
        `Unable to change capacity to ${newCapacity} because there are already ${
          session.members.length
        } members booked `
      )
      return
    }
    session.object.capacity = newCapacity
    this.db.save(session)
    await this.db.postNextSyncRequest()
  }

  @computed
  get isToday() {
    if (this.currentDate.format("MM-DD-YYYY") === dayjs().format("MM-DD-YYYY"))
      return true
    return false
  }

  @computed
  get sessionTimes(): string[] {
    return this.flow.sessionTypes
      ? this.flow.sessionTypes[0]
          .timeSlotsForDay(this.currentDate)
          .map(t => t.format("h:mma"))
      : []
  }

  @computed
  get sessions(): Session[][] {
    return this.flow.sessionTypes
      ? this.flow.sessionTypes
          .filter(s => s.object.name.toLowerCase() != "observe mo")
          .map(s => s.sessionsForDay(this.currentDate))
      : []
  }

  parseDate(str: string, format: any) {
    const parsed = dayjs(str).format(format)
    if (DateUtils.isDate(parsed)) {
      return parsed
    }
    return undefined
  }
}
